export const ColorSet = () => {
    return (
        ['#E45858', '#E4C558', '#657ADD', '#00910E', '#00BB99', '#0047B0', '#7F00AC', '#B9007A']
    );
}